/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { blackColor, cardTitle, hexToRgb } from "../../assets/jss/material-dashboard-pro-react.jsx";
import customSelectStyle from "../../assets/jss/material-dashboard-pro-react/customSelectStyle.tsx";
import customCheckboxRadioSwitch from "../../assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const JamezzFormStyles = (theme) => ({
  ...customCheckboxRadioSwitch,
  ...customSelectStyle,
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  label: {
    cursor: "pointer",
    paddingLeft: "0",
    color: "rgba(" + hexToRgb(blackColor) + ", 0.26)",
    fontSize: "14px",
    lineHeight: "1.428571429",
    textAlign: "right",
    fontWeight: "400",
    display: "inline-flex",
  },
  mrAuto: {
    marginRight: "auto",
  },
  mlAuto: {
    marginLeft: "auto",
  },
  customSwitchInputGridItem: {
    // marginTop: '30px',
  },
  selectInputGridItem: {
    // marginTop: '22px'
  },
  tagListGridItem: {
    // marginTop: '31px'
  },
  labelHorizontal: {
    color: blackColor,
    cursor: "pointer",
    display: "inline-flex",
    fontSize: "14px",
    lineHeight: "1.428571429",
    fontWeight: "400",
    paddingTop: "5px",
    textAlign: "right",
    marginRight: "0",
    "@media (min-width: 992px)": {
      float: "right",
    },
  },
});

export default JamezzFormStyles;
